"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var Image_1 = require("ContentTokens/Models/Image");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var ImageCdnHelper_1 = require("@CommonFrontendBackend/Utils/ImageCdnHelper");
var IsResizeableWidget_1 = require("@CommonFrontend/WidgetRegistry/Utils/IsResizeableWidget");
var CommonUtils_2 = require("@CommonFrontend/Public/Widgets/Image/CommonUtils");
var styles = __importStar(require("./Image.css"));
var commonStyles = __importStar(require("@CommonFrontend/Public/Widgets/Image/ImageCommon.css"));
var c = (0, BemBuilder_1.default)("image-widget");
var Image = function (_a) {
    var _b, _c;
    var _d, _e, _f, _g;
    var token = _a.token, options = _a.options, attributes = _a.attributes;
    if (!token.src && !token.uploadId) {
        return null;
    }
    if (!(0, IsResizeableWidget_1.isResizeableWidget)(token)) {
        throw new Error("Image is always resizeable");
    }
    var computedFrameAspectRatio = (0, CommonUtils_2.getFrameAspectRatio)(token);
    var widthStyles = calcWidthStyles(token, computedFrameAspectRatio);
    return (react_1.default.createElement("figure", __assign({}, attributes, { className: (0, classnames_1.default)(attributes.className, "project-block__block-element--image", (_b = {},
            _b[styles.imageContainerDefaultWidth] = token.width == undefined,
            _b)) }),
        react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                var _a;
                if (!token.href) {
                    return undefined;
                }
                return (react_1.default.createElement("a", { target: "_blank", rel: "noreferrer", href: token.href, className: (0, classnames_1.default)(c("link"), (_a = {}, _a[c("link", "circle")] = token.frame === Image_1.ImageFrame.Circle, _a)) }, children));
            } },
            react_1.default.createElement("div", { className: commonStyles.frame({ circle: token.frame === Image_1.ImageFrame.Circle }), style: (0, dynamic_1.assignInlineVars)((_c = {}, _c[commonStyles.frameAspectRatio] = computedFrameAspectRatio.toString(), _c)) },
                react_1.default.createElement("img", __assign({}, getImageSrcAttrs(token, options), { className: c("image"), style: __assign({ translate: token.translation ? "".concat((_d = token.translation.x) !== null && _d !== void 0 ? _d : 0, "% ").concat((_e = token.translation.y) !== null && _e !== void 0 ? _e : 0, "%") : undefined, scale: token.scale ? "".concat(token.scale) : undefined }, widthStyles) }, (0, CommonUtils_1.includeIf)(!!((_f = token.alt) === null || _f === void 0 ? void 0 : _f.value) && token.role !== "presentation", {
                    alt: (_g = token.alt) === null || _g === void 0 ? void 0 : _g.value,
                }), (0, CommonUtils_1.includeIf)(!!token.role, { role: token.role })))))));
};
var getImageSrcAttrs = function (token, options) {
    var _a, _b, _c;
    var disableImgix = options.disableImgix, isPrintMode = options.isPrintMode;
    var src = (_a = (0, ImageCdnHelper_1.getImageSrc)(token.src, options.disableImgix, options.isPrintMode
        ? {
            maxWidth: (0, ImageCdnHelper_1.getMaxWidthForPrint)(options.printOrientation),
            keepOriginalFormat: true,
        }
        : undefined)) !== null && _a !== void 0 ? _a : "";
    if (!isPrintMode) {
        var srcSet = (0, ImageCdnHelper_1.getImageSrcSet)(token.src, [744, 1280, 2550, 3525], disableImgix);
        if (srcSet.length > 0) {
            var sizesVw = 0;
            if (typeof token.width !== "string" || token.width === "content") {
                var imageWidthPerc = token.width === "content" ? 100 : (_b = token.width) !== null && _b !== void 0 ? _b : 100;
                var scale = (_c = token.scale) !== null && _c !== void 0 ? _c : 1;
                var containerViewportPerc = estimateImageContainerVw();
                sizesVw = (imageWidthPerc * scale * containerViewportPerc) / 100;
            }
            else {
                sizesVw = 100;
            }
            return {
                src: src,
                srcSet: srcSet,
                sizes: "".concat(sizesVw, "vw"),
            };
        }
    }
    return {
        src: src,
    };
};
var estimateImageContainerVw = function () {
    return 95;
};
exports.default = Image;
function calcWidthStyles(token, computedFrameAspectRatio) {
    if (!!token.aspectRatio) {
        var fillHeightPercent = (0, CommonUtils_2.calcFillHeightPercent)(token.aspectRatio, computedFrameAspectRatio);
        if (!!fillHeightPercent) {
            return { minWidth: fillHeightPercent, maxWidth: fillHeightPercent };
        }
    }
    return { width: "100%" };
}
